import {useFlag} from '@unleash/proxy-client-react';

const useGiftAdvisorV2Flag = () => useFlag('gift-advisor-v2-web');

export default useGiftAdvisorV2Flag;
